import React from "react";
import styles from "./CivilLaw.module.css";
import CustomTitle from "../components/CustomTitle";
//import LocationFooter from "./LocationFooter";
const MiningLaw = () => {
  return (
    <>
      <section className={styles.practiceAreas}>
        <CustomTitle>Mining Law</CustomTitle>

        <div className={styles.practiceList}>
          <div className={styles.practiceCard}>
            <p>
              Our firm has extensive expertise in mining laws and regulatory
              frameworks governing natural resources. We advise mining
              companies, investors, and contractors on licensing, environmental
              clearances, regulatory approvals, and compliance with state and
              central mining regulations. We also assist in dispute resolution
              relating to mining leases, royalties, and operational issues. With
              a deep understanding of environmental, land acquisition, and
              safety laws, we provide holistic support to ensure sustainable and
              legally sound mining operations.
            </p>
            <ul>
              <li>Mining lease agreements.</li>
              <li>Representation before tribunals.</li>
              <li>Legal audits and compliance.</li>
              <li>MMDR, EIA, and Forest Act guidance.</li>
            </ul>
          </div>
        </div>
      </section>
      {/*  <LocationFooter /> */}
    </>
  );
};

export default MiningLaw;
